export const getISOWeekNumber = (date: Date): number => {
  const tempDate = new Date(date.valueOf());
  const dayNum = (date.getDay() + 6) % 7;
  tempDate.setDate(tempDate.getDate() - dayNum + 3);
  const firstThursday = tempDate.valueOf();
  tempDate.setMonth(0, 1);
  if (tempDate.getDay() !== 4) {
    tempDate.setMonth(0, 1 + ((4 - tempDate.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - tempDate.valueOf()) / 604800000);
};

export const getDaysInMonth = (year: number, month: number): number => {
  return new Date(year, month + 1, 0).getDate();
};

export const getFirstDayOfMonth = (year: number, month: number): number => {
  return new Date(year, month, 1).getDay();
};

export const getDateKey = (year: number, month: number, day: number): string => {
  return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const parseDate = (dateKey: string): { year: number; month: number; day: number } => {
  const parts = dateKey.split('-').map(Number);
  return { year: parts[0], month: parts[1] - 1, day: parts[2] };
};

export const getCellRange = (start: string, end: string): string[] => {
  if (!start || !end) return [];

  const startParts = start.split('-').map(Number);
  const endParts = end.split('-').map(Number);

  let startDate = new Date(startParts[0], startParts[1] - 1, startParts[2]);
  let endDate = new Date(endParts[0], endParts[1] - 1, endParts[2]);

  if (startDate > endDate) {
    [startDate, endDate] = [endDate, startDate];
  }

  const range: string[] = [];
  const current = new Date(startDate);

  while (current <= endDate) {
    range.push(getDateKey(current.getFullYear(), current.getMonth(), current.getDate()));
    current.setDate(current.getDate() + 1);
  }

  return range;
};

export const dateRangeToSelectedCells = (start: string, end: string): string[] => {
  return getCellRange(start, end);
};

export const getCellsInRange = (start: string, end: string): Set<string> => {
  return new Set(getCellRange(start, end));
};

export const isToday = (year: number, month: number, day: number): boolean => {
  const today = new Date();
  return (
    year === today.getFullYear() &&
    month === today.getMonth() &&
    day === today.getDate()
  );
};

export const isPastDate = (year: number, month: number, day: number): boolean => {
  const date = new Date(year, month, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const isWeekend = (dayIndex: number): boolean => {
  return dayIndex === 0 || dayIndex === 6;
};